<template>
    <div>
        <router-link v-if="isLink" :to="`/topic/${topic.id}`">
            <b class="u-text-tiny" v-if="topic.subtitleTop">{{ topic.subtitleTop }}</b>
            {{ topic.title }}
            <b class="u-text-tiny" v-if="topic.subtitleBottom">{{ topic.subtitleBottom }}</b>
        </router-link>

        <div v-if="!isLink">
            <b class="u-text-tiny" v-if="topic.subtitleTop">{{ topic.subtitleTop }}</b>
            {{ topic.title }}
            <b class="u-text-tiny" v-if="topic.subtitleBottom">{{ topic.subtitleBottom }}</b>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TopicTitle",
        props: ["topic", "isLink"],
    }
</script>

<style scoped>

</style>
